<template>
    <v-row>  <v-chip
        elevation="9"
        color="#f78da7"
        variant="elevated"
        class="rounded-lg"
        size="large"
        style="text-align: center; margin-left: 15px; color: white; margin-top: 10px"
    >
       Human Resources
    </v-chip></v-row>
    <v-row>
        <v-col cols="12" lg="4" md="6" sm="12" xs="12">
            <EmployeeCount company="D3" />
        </v-col>
        <v-col cols="12" lg="4" md="6" sm="12" xs="12">
            <EmployeeCount company="Conex" />
        </v-col>
        <v-col cols="12" lg="4" md="6" sm="12" xs="12">
            <EmployeeCount company="Prugent" />
        </v-col>
        <v-col cols="12" lg="4" md="6" sm="12" xs="12">
            <EmployeeCount company="B2D" />
        </v-col>
        <v-col cols="12" lg="4" md="6" sm="12" xs="12">
            <EmployeeCount company="FieldFlex" />
        </v-col>
        <v-col cols="12" lg="4" md="6" sm="12" xs="12">
            <ShiftCount />
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12">
            <NotClockedOut />
        </v-col>
        <v-col cols="12">
<!--            <ExpiredTimeOff />-->
        </v-col>
    </v-row>
</template>

<script>
import { defineAsyncComponent } from "vue";

const EmployeeCount = defineAsyncComponent(() =>
    import("../../components/Hr/EmployeeCount/EmployeeCount.vue")
);
const ShiftCount = defineAsyncComponent(() =>
    import("../../components/Hr/EmployeeCount/ShiftCount.vue")
);
const NotClockedOut = defineAsyncComponent(() =>
    import("../../components/Hr/EmployeeCount/NotClockedOut.vue")
);
const ExpiredTimeOff = defineAsyncComponent(() =>
    import("../../components/Hr/EmployeeCount/ExpiredTimeOff.vue")
);
export default {
    components: {
        EmployeeCount,
        ShiftCount,
        NotClockedOut,
        ExpiredTimeOff,
    },
};
</script>
<style scoped>
.flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
}

.flex-item {
    height: 175px;
    margin: 10px auto;
}
</style>
